import { render, staticRenderFns } from "./epmsa230.vue?vue&type=template&id=2ace7b66&scoped=true"
import script from "./epmsa230.vue?vue&type=script&lang=js"
export * from "./epmsa230.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ace7b66",
  null
  
)

export default component.exports